import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import Button from "@/components/button";
import CurrencyInput from "react-currency-masked-input";
import { getLocalisationVal, transformInput } from "@/utils/localizationUtil";
import useStyles from "./styles";

const CurrencyComponent = ({ localization, defaultPrice, onAdd }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [price, setPrice] = useState(defaultPrice);
  const [focused, setFocused] = useState(false);
  const hasAddClicked = useRef(false);

  const onBlur = () => {
    if (!hasAddClicked.current) {
      setPrice(defaultPrice);
    }
    setFocused(false);
    hasAddClicked.current = false;
  };

  const onClickAdd = () => {
    hasAddClicked.current = true;
    onAdd(price);
  };

  return (
    <div style={{ position: "relative" }}>
      <CurrencyInput
        value={getLocalisationVal(localization, price)}
        onChange={(e, value) => setPrice(transformInput(localization, value))}
        className={classes.currencyInput}
        type=""
        separator={localization.digit_separator === "," ? "." : ","}
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setTimeout(onBlur, 200);
        }}
      />
      {focused && (
        <Box position={"absolute"} top={-6} right={-70}>
          <Button
            disabled={parseFloat(price) == parseFloat(defaultPrice)}
            color="primary"
            variant="contained"
            className={classes.addButton}
            onClick={onClickAdd}
          >
            {t("purchase_screen.add")}
          </Button>
        </Box>
      )}
    </div>
  );
};

export default CurrencyComponent;
